import { render, staticRenderFns } from "./operateTrends.vue?vue&type=template&id=0b23aace&scoped=true&"
import script from "./operateTrends.vue?vue&type=script&lang=js&"
export * from "./operateTrends.vue?vue&type=script&lang=js&"
import style0 from "./operateTrends.vue?vue&type=style&index=0&id=0b23aace&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23aace",
  null
  
)

export default component.exports